'use client'

import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { getAdConfig, isGoogleAdEnabledByGenre } from '@/lib/advertising'
import Script from 'next/script'
import { PropsWithChildren } from 'react'

function GoogleAdSenseWrapper({ children }: PropsWithChildren) {
  const enableFull3d = useEnableFull3d()
  const { roomData } = useCheckEnterRoomContext()
  const genres = roomData.tags

  const { isGoogleAdEnabled, googleAdClientId } = getAdConfig()
  const isAdEnabledByGenre = isGoogleAdEnabledByGenre(genres)
  const shouldShowAd = isGoogleAdEnabled || isAdEnabledByGenre
  const GOOGLE_ADSENSE_SCRIPT_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${googleAdClientId}`

  return (
    <>
      {!enableFull3d && shouldShowAd && (
        <Script
          async
          src={GOOGLE_ADSENSE_SCRIPT_SRC}
          strategy="afterInteractive"
          crossOrigin="anonymous"
        />
      )}
      {children}
    </>
  )
}

export default GoogleAdSenseWrapper
